@if (isOpen || isPermanent()) {
  <div class="loading-indicator" [ngClass]="{ embedded: isEmbedded(), small: isSmall() }">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>
}
